// import { MDBBtn, MDBCard, MDBCardBody, MDBContainer, MDBIcon, MDBTypography } from "mdb-react-ui-kit";
import { Card, CardContent, Typography } from "@mui/material";
import "./ChatComponent.css"; // Import the CSS file for styling
// import DoubleClickDialog from "../../api/common/components/clickDialogue";
// import ResponseComponent from "./ResponseComponent";
import AssistantSharpIcon from "@mui/icons-material/AssistantSharp";
import TextSizeContext from "../../api/common/components/TextSizeContext";
import React, { useState,useRef,useEffect } from "react";

interface Props {
  chatXai: string;
  handleLike?: (index: number) => void;
  handleDislike?: (index: number) => void;
  likes?: ("like" | "dislike" | null)[];
  isLoading: boolean;
}

export default function XaiOutput({
  chatXai,
  handleLike,
  handleDislike,
  likes,
  isLoading,
}: Props){
    const chatHistoryRef = useRef<HTMLDivElement>(null);
      
        // Scroll to bottom function
        const scrollToBottom = () => {
          if (chatHistoryRef.current) {
            chatHistoryRef.current.scrollTop = chatHistoryRef.current.scrollHeight;
          }
        };
      
        useEffect(() => {
          scrollToBottom();
        }, [chatXai]);
  return (
    <>
        <div ref={chatHistoryRef} style={{ maxHeight: "400px", overflowY: "auto" }}>
      <Card>
        <CardContent className="bot-response">
          {/* <DoubleClickDialog /> */}
          <AssistantSharpIcon />
          {chatXai && chatXai.trim() !== "" ? (
            <TextSizeContext context={chatXai} />
          ) : (
            <Typography variant="body2" color="text.secondary" fontStyle="italic">
              Awaiting explanation...
            </Typography>
          )}
        </CardContent>
      </Card>

      {isLoading && (
        <Typography sx={{ mt: 1 }} className="text-info">
          <strong>loading:</strong>...
        </Typography>
      )}
    </div>
    </>
  );
}

// export {}
